import { trackPageView } from "./snowplowEventTrackers";
import { enableSnowplowPlugins } from "./snowplowPlugins";
import { composeChannelCategoryContextData } from "./snowplowTracking";
import { getDynamicSchemaContext, getSnowplowVariables, hasUserAcceptedAllConsent, getAvailableTopics, getSchemaName } from "./utils";

export function snowplowInit() {
    if (typeof jest !== 'undefined' || process.env.NODE_ENV === 'test') {
        return;
    }

    const { appId, collectorUrl, nameSpace } = getSnowplowVariables();

    const hasConsent = hasUserAcceptedAllConsent();

    const snowplowConfig = {
        appId,
        cookieSameSite: 'Lax',
        cookieName: "mls_sp",
        anonymousTracking: hasConsent ? false : {
            withSessionTracking: false,
            withServerAnonymisation: true
        },
        contexts: {
            webPage: true,
            session: hasConsent,
            performanceNavigationTiming: true,
            performanceTiming: true,

        }
    }

    window?.snowplow('newTracker', nameSpace, collectorUrl, snowplowConfig);

    enableSnowplowPlugins();
}

export function trackPageLoad() {
    const { entityContexts, pageType } = getSnowplowVariables();

    if (!entityContexts?.length && pageType !== 'video') {
        const contexts = [composeChannelCategoryContextData()];
        const schemaName = getSchemaName();
        const dynamicSchemaContext = getDynamicSchemaContext(schemaName);


        if (pageType === "news") {
            const topics = getAvailableTopics(schemaName);

            if (topics?.length) {
                contexts.push(...topics);
            }
        }

        if (dynamicSchemaContext) {
            contexts.push(dynamicSchemaContext);
        }

        trackPageView({
            contexts,
        });
    }
}

export async function setupAuth0UserTracking() {
    if (typeof jest !== 'undefined' || process.env.NODE_ENV === 'test') {
        return;
    }

    const hasConsent = hasUserAcceptedAllConsent();

    if (hasConsent) {
        if (window?.auth0Client) {
            const user = await window?.auth0Client?.getUser();
            if (user?.sub) {
                window.snowplow("disableAnonymousTracking");
                window?.snowplow?.('setUserId', user?.sub);
            }
        }
    }

    trackPageLoad();
    window?.OneTrust?.OnConsentChanged(onConsentChanged);
}

function onConsentChanged() {
    const hasConsent = hasUserAcceptedAllConsent();

    if (!hasConsent) {
        clearUserTracking();
    } else {
        if (window?.auth0Client) {
            window.snowplow("disableAnonymousTracking");
            setupUserIdIfLoggedIn();
        }
        trackPageLoad();
    }
}

async function setupUserIdIfLoggedIn() {
    if (window?.auth0Client) {
        const user = await window?.auth0Client?.getUser();
        if (user?.sub) {
            window.snowplow("disableAnonymousTracking");
            window?.snowplow?.('setUserId', user?.sub);
        }
    }
}

export async function clearUserTracking() {
    if (typeof jest !== 'undefined' || process.env.NODE_ENV === 'test') {
        return;
    }

    window.snowplow('clearUserData', { preserveSession: false, preserveUser: false });
    window.snowplow("enableAnonymousTracking", {
        withSessionTracking: false,
        withServerAnonymisation: true
    });
}